export const INACTIVE_MODAL_STYLES = {
  MODAL_CONTAINER:
    'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[504px] pb-4 bg-bw02 rounded-lg flex flex-col justify-center items-center pt-[2.125rem] px-[3rem] z-[100]',
  ICON: 'max-w-[5.25rem] max-h-[5.25rem] my-[3.313rem]',
  TEXT_1: 'text-base font-metricMedium text-bw08 mb-[1rem]',
  TEXT_2: 'text-base inline-block text-center font-metric text-bw07 mb-[5.438rem]',
  COUNTER: 'text-action03 font-metricMedium',
  STAY_LOGIN_BTN: 'w-[10rem] h-[3rem] bg-action03 text-bw00 text-sm font-metricSemibold rounded-umd hover:bg-action04',
  LOGOUT_BTN: 'w-[10rem] h-[3rem] text-bw06 text-sm',
};

export const INACTIVE_LABELS = {
  STILL_WITH_US: 'INACTIVE_LABELS_STILL_WITH_US',
  YOUVE_BEEN_GONE: 'INACTIVE_LABELS_YOUVE_BEEN_GONE',
  STAY_IN: 'INACTIVE_LABELS_STAY_IN',
  LOG_OUT: 'INACTIVE_LABELS_LOG_OUT',
} as const;
